<template>
    <div class="auth scrollable" :style="{backgroundImage: 'url('+(config.background)+')'}">
        <div class="fading">
            <loading-screen v-if="wip"/>
            <div class="mobile">
                <div class="text-center logo">
                    <img :src="config.logo"  style="margin:60px 0;"/>
                </div>
                <div class="form">
                    <div class="inputs">
                        <input type="text" class="signInInput" v-model="login" placeholder="Телефон">
                        <input type="password" class="signInInput" v-model="password" placeholder="Пароль">
                    </div>
                    <br/>
                    <btn m @press="signIn" label="Вход" t="p" s="xl"/>
                    <div @touchstart="signUpModalOpened = true" style="margin:20px 0;font-size:18px;">
                        <a style="color:white">Регистрация</a>
                    </div>
                    <div @touchstart="passwordResetModalOpened = true" style="margin:20px 0;font-size:18px;">
                        <a style="color:white">Сбросить пароль</a>
                    </div>
                </div>
                <div style="color:white;margin:5px;background:rgba(0,0,0,0.8);display:inline-block;padding:5px 10px;border-radius:5px;">
                    build 17778
                </div>

                <button @click="codeConfirmModalOpen = true">1</button>
                <button @click="passwordResetModalOpened = true">2</button>
                <button @click="passwordResetCodeModalOpened = true">3</button>

                <!--<btn s="xl" m @press="passwordResetCodeModalOpened = true" l="ok"/>-->

                <imodal :shown="signUpModalOpened">
                    <h3>Регистрация в Автопоиск</h3>
                    <!--<inputi m label="Фамилия" v-model="name" placeholder="Фамилия"/>
                    <inputi m label="Имя" v-model="surname" placeholder="Имя"/>
                    <list-select
                            label="Выберит свой город"
                            :required="true" m
                            :options="cities"
                            v-model="city"
                    />
                    <list-select
                            label="Тип пользователя"
                            :required="true" m
                            :options="[{label:'Пользователь',value:false},{label:'Исполнитель',value:true}]"
                            @change="(s)=>{isSupplier=s}"
                            :value="isSupplier"
                    />-->
                    <inputi m label="Телефон" v-model="login" placeholder="Телефон"/>

                    <inputi m label="Пароль" type="password" v-model="password" placeholder="Пароль"/>
                    <inputi m label="Пароль еще раз" type="password" v-model="passwordRepeat" placeholder="Пароль  еще раз"/>

                    <span style="color:red;">Внимание!</span>
                    Перед тем как продолжить, ознакомтесь с
                    <span style='color:blue;text-decoration:underline' @touchstart="agreementModalOpened = true">пользовательским соглашением</span>
                    <div style="margin:20px 0;">
                        <label for="agreement"><input type="checkbox" id="agreement" v-model="agree"> Я принимаю пользовательское соглашение</label>
                    </div>
                    <btn m l='Регистрация' s='xl' t="s" @press="signUp"/>
                    <btn m l='Отмена' s='xl' t="d" @press="signUpModalOpened = false"/>
                </imodal>
                <imodal :shown="agreementModalOpened" :full="true">
                    <h3>Пользовательское соглашение</h3>
                    <div style="text-align:left;height:calc(100% - 120px);margin-bottom:10px;overflow:scroll">
                        But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?
                        But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?
                    </div>
                    <btn label="Ознакомлен" m s="xl" t="s" @press="agreementModalOpened = false"/>
                </imodal>

                <imodal :shown="codeConfirmModalOpen">
                    <h3>Введите код из СМС</h3>
                    <input
                            inputmode="numeric"
                            style="border-radius:20px;outline:none;margin:10px 0 18px;"
                            type="number"
                            placeholder="xxxxxx"
                            max="1"
                            pattern="[0-9]*"

                            :value="code"
                            maxlength="6"
                            class="code"
                            @keyup="codeChange"
                    />
                    <btn m style='border-radius:20px;' s="xl" t="d" l="Отмена" @press="codeConfirmModalOpen = false"/>
                </imodal>
                <imodal :shown="passwordResetModalOpened">
                    <h3>Сброс пароля</h3>
                    <inputi m label="Телефон" v-model="login" placeholder="Телефон"/>
                    <btn m l='Сбросить пароль' s='xl' t="s" @press="resetPassword"/>
                    <btn m l='Отмена' s='xl' t="d" @press="passwordResetModalOpened = false"/>
                </imodal>


                <imodal :shown="passwordResetCodeModalOpened">
                    <h3>Введите код из СМС</h3>
                    <inputi m label="Код из СМС" type="number" v-model="code" placeholder="Код из СМС"/>
                    <inputi m label="Новый пароль" type="password" v-model="password" placeholder="Пароль"/>
                    <btn m  s="xl" t="s" l="Отправить код" @press="confirmPasswordReset"/>
                    <btn m s="xl" t="d" l="Отмена" @press="passwordResetCodeModalOpened = false"/>
                </imodal>

            </div>
        </div>

    </div>
</template>

<script>
    /**
     * Created by zato93 on 10/3/17.
     */
    import methods from "../auth.methods";
    export default methods;

</script>


<style scoped>
    html, body, #root {
        height: 100%;
    }
    .auth {
        background-size: 256px;
        height: 100%;
    }

    .fading{
        height:100%;
        background:rgba(0, 48, 113, 0.73);
    }

    .mobile {
        height: 100%;
        text-align: center;
        height: 100%;
        background-size: cover;
    }

    .logo img {
        width: 80%;
        margin: 30px 0px;
    }

    .form {
        padding: 20px 25px;
        border-radius: 10px;

    }

    .signInInput{
        -webkit-appearance: none;
        border:1px solid lightgrey;
        padding:10px 16px;
        font-size:18px;
        width:100%;
        outline:none;
        border-radius:0;
    }
    .signInInput:first-child{
        border-top-right-radius:6px;
        border-top-left-radius:6px;
    }
    .signInInput:last-child{
        border-bottom-right-radius:6px;
        border-bottom-left-radius:6px;
        margin-top:-2px;
    }


    .code-confirm-modal input{
        width: 204px;
    }

    .code-confirm-modal .iwrapper {
        width: 300px;
        left: 50%;
        top: 50%;
        margin-left: -150px;
        margin-top: -150px;
        position: absolute;
    }


    .code {
        padding: 6px 12px;
        border: 1px solid lightgrey;
        width: 100%;
        font-size: 24px;
        display: inline-block;
        text-align: center;
        letter-spacing: 12px;

    }

    .sign-up-modal{
    }
</style>

